module.exports = __webpack_public_path__ + "static/media/questions_active.8da4db18.svg";